import type { ReactNode } from "react";
import type { Case } from "@/lib/useRealtimeCases";
import { RappelBlock } from "./RappelBlock";
import { RelancesDevisBlock } from "./RelancesDevisBlock";
import { RelancesHistory } from "./RelancesHistory";
import { useCaseRelances } from "./useCaseRelances";

export interface CaseRelancesColumnProps {
  caseData: Case; // fiche complète chargée par le drawer
  onFieldChange: (field: keyof Case, value: unknown) => void; // auto-save existant du drawer (debounce)
  tasksSlot?: ReactNode; // bloc tâches (Lot B), affiché en haut de colonne
}

/**
 * Colonne de droite de la fiche dossier : tâches, rappel téléphonique, relances devis et historique.
 * Remplace la page /relances pour UN dossier.
 */
export function CaseRelancesColumn({ caseData, onFieldChange, tasksSlot }: CaseRelancesColumnProps) {
  const state = useCaseRelances(caseData.id, caseData.status);
  return (
    <aside aria-labelledby="case-relances-title" className="flex h-full min-h-0 flex-col bg-white">
      {/* Même hauteur (44 px) que les en-têtes des colonnes voisines (classe définie par la coque, Lot C1). */}
      <div className="case-column-header flex h-11 flex-none items-center border-b border-gray-200 bg-white px-4">
        <h3 id="case-relances-title" className="text-sm font-semibold text-gray-900">
          Relances
        </h3>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        {tasksSlot && <div className="border-b border-gray-200">{tasksSlot}</div>}
        <RappelBlock caseData={caseData} onFieldChange={onFieldChange} />
        <RelancesDevisBlock caseData={caseData} state={state} />
        <RelancesHistory caseId={caseData.id} state={state} />
      </div>
    </aside>
  );
}

export default CaseRelancesColumn;
